export default __webpack_public_path__ + "static/media/TableTracking-100k.b00bf875.png";